import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './PasswordForm.module.scss';
import MeritoCheckbox from '../../../Finance/components/CustomCheckbox/MeritoCheckbox';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import { BiShow, BiHide } from 'react-icons/bi'; // Import eye icons from react-icons
import { IpRestS } from '../../../../rest/ipRest-service';
import { IIntegrationPartner, integrationAuthFormFields, ipEmailClients, IpNames, PENDING_CREDENTIAL_CONFIRMATION_IPS, UserRole, validationErrorTypes } from '../../../../interfaces/interfaces';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../redux/reduxHooks';
import { clearCrendentialVerificationDetails } from '../../../../redux/credentialVerification/credentialVerification';
import { MdMailOutline as MailIcon } from 'react-icons/md'
import { ipShortNames } from '../../EmailOtp/emailOtpHelper';
import { Field, Form } from 'react-final-form';
import { cutomEmailValidation, emailValidation } from '../../../../components/functions/formValidation';
import { getLocalUser } from '../../../../components/functions/utilities';

const defaultShowFields = new Set([integrationAuthFormFields.email, integrationAuthFormFields.password])

type Props = {
	ip: IIntegrationPartner;
	setStep: Function;
	isNestedStep?: boolean;
	showFields?: Set<integrationAuthFormFields>;
	initialValues?: any;
	showTnC?: boolean;
	handleFormSubmit?: (value: any) => void;
	showHeader?: boolean;
	setSelectedIp?: (value: IIntegrationPartner) => void;
	setSuccess?: (value: boolean) => void;
};

const emailClients = [
    {
        name: 'Gmail',
        logo: <><img src="https://assets.clickmerito.com/images/gmail.png" alt="" /></>,
        value: ipEmailClients.gmail
    },
    {
        name: 'Outlook',
        logo: <><img src="https://assets.clickmerito.com/images/outlook.png" /></>,
        value: ipEmailClients.outlook
    },
    {
        name: 'Others',
        logo: <><MailIcon /></>,
        value: ipEmailClients.others
    }
]

const emailOrUsernameIps = new Set([]);

const handleInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
	e.currentTarget.readOnly = false;
};

export const setRPAValidationObj = () => {
    window.localStorage.setItem('validatingRPAExpiry', String(new Date(new Date().getTime() + 5 * 60000).getTime()));
}

export const PasswordForm = ({
	ip,
	setStep,
	isNestedStep,
	showFields = defaultShowFields,
	initialValues = null,
	showTnC = true,
	handleFormSubmit = () => {},
	showHeader = false,
	setSelectedIp = () => {},
	setSuccess = () => {},
}: Props) => {
	const dispatch = useAppDispatch();
	const isFirstRender = useRef(true); // Flag to track first render

	const [disableSubmit, setDisableSubmit] = useState(true);
	const initialStates = {
		email: "",
		password: "",
		emailClient: "",
	};
	// Regular expression for basic email validation
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	const [form, setForm] = useState(initialStates);
	const [errors, setErrors] = useState(initialStates);

	const currentUser = getLocalUser();
	const { currentClient } = useAppSelector((state) => state.agencyConfig);

	useEffect(() => {
		if (initialValues) {
			setForm(initialValues);
		}
	}, [initialValues]);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		return () => {
			console.log("RUNNING CLEANUP FUNCTION");
			dispatch(clearCrendentialVerificationDetails());
		};
	}, []);

	const disableBtn = useMemo(() => {
		let emailCheck = showFields?.has(integrationAuthFormFields.email)
			? emailOrUsernameIps.has(ip?.companyName as IpNames)
				? form?.email?.length
				: emailRegex.test(form.email)
			: true;
		let emailClientCheck = showFields?.has(integrationAuthFormFields.emailClient)
			? form?.emailClient?.length
			: true;
		let passwordCheck = showFields?.has(integrationAuthFormFields.password)
			? form?.password?.length
			: true;

		// console.log('emailCheck', emailCheck)
		if (!emailCheck || !emailClientCheck || !passwordCheck) {
			// setDisableSubmit(true)
			return true;
		} else {
			// setDisableSubmit(false)
			return false;
		}
	}, [form, showFields]);

	const handleChange = (e) => {
		const field = e.target.name;
		const value = e.target.name == "termsChecked" ? e.target.checked : e.target.value;
		var formObj = {
			...form,
			[field]: value,
		};
		console.log("formObj", formObj);
		setForm(formObj);

		if (emailRegex.test(formObj.email)) {
			setErrors({ ...errors, email: "" });
		}
	};

	useEffect(() => {
		console.log(errors);
	}, [errors]);

	const handleSubmit = (formValuesFromParam) => {
		// if (!emailRegex.test(form.email) && !emailOrUsernameIps.has(ip?.companyName as IpNames)) {
		//     setErrors(props => ({
		//         ...props,
		//         email: 'Invalid email address'
		//     }))
		//     return;
		// }

		console.log(`Submitting Form with details: `, form);
        console.log("------------ IP:", {ip})

		if (isNestedStep) {
			handleFormSubmit(formValuesFromParam);
			return;
		}
		if (PENDING_CREDENTIAL_CONFIRMATION_IPS.has(ip.companyName as IpNames)) {
            console.log("IN IF........")
			// Need to set `selectedIp` to the `ip` value
			setSelectedIp(ip);
			setSuccess(true);
			setStep(4);
		} else {
            console.log("IN ELSE........")
			setStep(9);
		}
		IpRestS.connectViaPasswordForm({
			email: formValuesFromParam?.email,
			password: formValuesFromParam?.password,
			integrationPartner: ip,
			agencyClientId: currentUser?.role === UserRole?.Agency ? currentClient?.id : null,
		});
		setRPAValidationObj();
	};

	const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility

	// Toggle the visibility of the password
	const togglePasswordVisibility = () => {
		setShowPassword((prevState) => !prevState);
	};

	const shortIpName = ipShortNames[ip?.name] ?? ip?.companyName;

	return (
		<div className={styles.credentialsRootContainer}>
			{showHeader ? (
				<div className={styles.headerContainer}>
					<div className={styles.ipLogoContainer}>
						<img src={ip?.logo} />
					</div>
					<div className={styles.headerText}>
						Connect Your <span>{shortIpName}</span> Account
					</div>
				</div>
			) : null}
			<div className={styles.container}>
				<Form
					onSubmit={handleSubmit}
					initialValues={{
						...initialStates,
						...initialValues,
					}}
					render={({ handleSubmit, pristine, hasValidationErrors }) => (
						// <form autoComplete='new-password' onSubmit={handleSubmit}>
						<div className={styles.formContainer}>
							{showFields?.has(integrationAuthFormFields.email) ? (
								<Field
									name="email"
									validate={(value) => {
										const errorType = emailValidation(value);
										if (errorType == validationErrorTypes.required) {
											return "Enter Email Address";
										} else if (errorType == validationErrorTypes.invalid) {
											return "Invalid Email Address";
										}
										return "";
									}}
								>
									{(props) => {
										return (
											<div className={styles.field}>
												<label>
													{emailOrUsernameIps.has(
														ip?.companyName as IpNames
													)
														? `Registered Username or Email Address`
														: `Registered Email Address`}
												</label>
												<input
													{...props.input}
													name={props.input.name}
													autoComplete="new-password"
													readOnly={true}
													value={props.input.value}
													className={`${styles.inputField} ${props?.meta?.error && props?.meta?.touched ? styles.errorBorders : ""}`}
													type="email"
													onChange={props.input.onChange}
													placeholder="Email"
													onFocus={handleInputFocus}
												/>
												{/* {
                                                        errors?.email?.length ?
                                                            <label className={styles.errorLabel}>{errors?.email}</label>
                                                            : null
                                                    } */}
												{props.meta.error && props.meta.touched ? (
													<label className={styles.errorLabel}>
														{props.meta.error}
													</label>
												) : null}
											</div>
										);
									}}
								</Field>
							) : null}

							{showFields?.has(integrationAuthFormFields.password) ? (
								<Field
									name="password"
									validate={(value) => {
										if (!value) {
											return "Enter Password";
										}
										return "";
									}}
								>
									{(props) => {
										return (
											<div className={styles.field}>
												<label>Password</label>
												<div
													className={`${styles.passwordEle} ${props?.meta?.error && props?.meta?.touched ? styles.errorBorders : ""}`}
												>
													<input
														{...props.input}
														name={props.input.name}
														autoComplete="new-password"
														readOnly={true}
														type={showPassword ? "text" : "password"} // Toggle input type based on state
														value={props.input.value}
														onChange={props.input.onChange}
														placeholder="Enter password"
														onFocus={handleInputFocus}
													/>
													{/* Eye icon to toggle visibility */}
													<span onClick={togglePasswordVisibility}>
														{showPassword ? <BiHide /> : <BiShow />}
													</span>
												</div>
												{props.meta.error && props.meta.touched ? (
													<label className={styles.errorLabel}>
														{props.meta.error}
													</label>
												) : null}
											</div>
										);
									}}
								</Field>
							) : null}
							{showFields?.has(integrationAuthFormFields.emailClient) ? (
								<Field
									name="emailClient"
									validate={(value) => {
										if (!value) {
											return "Select Email Client";
										}
										return "";
									}}
								>
									{(props) => {
										return (
											<div className={styles.field}>
												<label>Select Email Client</label>
												<div className={styles.emailClientContainer}>
													{emailClients.map((client, index) => {
														return (
															<div
																className={`${styles.emailClientItem} ${props.input?.value == client?.value ? styles.active : ""}`}
																onClick={() => {
																	props.input.onChange({
																		target: {
																			name: "emailClient",
																			value: client.value,
																		},
																	});
																}}
															>
																<div
																	className={styles.iconContainer}
																>
																	{client.logo}
																</div>
																<div
																	className={
																		styles.titleContianer
																	}
																>
																	{client.name}
																</div>
															</div>
														);
													})}
												</div>
												{/* {errors?.emailClient?.length ?
                                                        <label className={styles.errorLabel}>{errors?.emailClient}</label>
                                                        : null} */}
												{props.meta.error && props.meta.touched ? (
													<label className={styles.errorLabel}>
														{props.meta.error}
													</label>
												) : null}
											</div>
										);
									}}
								</Field>
							) : null}
							{showTnC ? (
								<div className={styles.disclaimer}>
									<p>
										By proceeding, you agree to Merito’s{" "}
										<span onClick={() => setStep(8)}>terms and conditions</span>
										.
									</p>
								</div>
							) : null}
							<MeritoButton
								type="primary-1"
								size="md2"
								btnText={"Continue"}
								onClick={handleSubmit}
								extraStyles={{ width: "100%", borderRadius: "10rem" }}
							/>
						</div>

						// </form>
					)}
				/>

				{/* {defaultShowFields?.has(integrationAuthFormFields.email) ? <div className={styles.field}>
                    <label>{emailOrUsernameIps.has(ip?.companyName as IpNames) ? `Registered Username or Email Address` : `Registered Email Address`}</label>
                    <input autoComplete='new-password' value={form?.email} className={`${styles.inputField} ${errors?.email?.length ? styles.errorBorders : ''}`} name="email" type="email" onChange={(e) => handleChange(e)} placeholder='Email' />
                    {
                        errors?.email?.length ?
                            <label className={styles.errorLabel}>{errors?.email}</label>
                            : null
                    }
                </div> : null}
                {showFields?.has(integrationAuthFormFields.password) ? <div className={styles.field}>
                    <label>Password</label>
                    <div className={styles.passwordEle}>
                        <input
                            autoComplete='new-password'
                            name="password"
                            type={showPassword ? 'text' : 'password'}  // Toggle input type based on state
                            autoComplete="new-password"
                            value={form?.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                        />
                        <span onClick={togglePasswordVisibility}>
                            {showPassword ? <BiHide /> : <BiShow />}
                        </span>
                    </div>
                </div> : null}
                {showFields?.has(integrationAuthFormFields.emailClient) ?
                    <div className={styles.field}>
                        <label>
                            Select Email Client
                        </label>
                        <div className={styles.emailClientContainer}>
                            {emailClients.map((client, index) => {
                                return (
                                    <div className={`${styles.emailClientItem} ${form?.emailClient == client?.value ? styles.active : ''}`} onClick={() => {
                                        handleChange({ target: { name: 'emailClient', value: client.value } })
                                    }}>
                                        <div className={styles.iconContainer}>
                                            {client.logo}
                                        </div>
                                        <div className={styles.titleContianer}>
                                            {client.name}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {errors?.emailClient?.length ?
                            <label className={styles.errorLabel}>{errors?.emailClient}</label>
                            : null}
                    </div> : null}
                {showTnC ? <div className={styles.disclaimer}>
                    <p>By proceeding, you agree to Merito’s <span onClick={() => setStep(8)}>terms and conditions</span>.</p>
                </div> : null}
                <MeritoButton type="primary-1" size="md2" btnText={"Continue"} disabled={disableBtn} onClick={handleSubmit} extraStyles={{ 'width': '100%', 'borderRadius': '10rem' }} /> */}
			</div>
		</div>
	);
};